<template>
    <section class="base-header-sec base-header-laen  laen">
        <div class="base-header__top-line laen"></div>
        <div class="container-fluid">
            <div class=" container-lg  base-header__container ">
                <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                    <h2 class="base-header__title mob d-block d-lg-none">
                        {{title}}
                    </h2>
                    <ul class="nav ">
                        <li class="nav-item">
                            <router-link class="nav-link" :to="'/slglrs' + slug + '-overview/all'">Преглед</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" :to="'/slglrs' + slug + '-all-issues'">Сви бројеви
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" :to="'/slglrs' + slug + '-search'">Претрага</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link "
                                         :to="{ path: '/slglrs-static', query: { page: 'help' ,code:slug}}">
                                Помоћ
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link "
                                         :to="{ path: '/slglrs-static', query: { page: 'contact' ,code:slug}}">
                                Контакт
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link "
                                         :to="{ path: '/slglrs-static', query: { page: 'impresum' ,code:slug}}">
                                Импресум
                            </router-link>
                        </li>
                    </ul>
                    <h1 class="base-header__title d-none d-lg-block">
                        <!--                            <span class="base-header__icon icon-inbox mr-3"></span>-->
                        {{title}}
                        <!--                            СЛУЖБЕНИ ГЛАСНИК РС-->
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "SlglrsBaseHeaderSec",
        props: ['title', 'slug'],
        // computed: {
        //     staticPageSlug() {
        //         let extCode = null;
        //         // switch (this.slug) {
        //         //     case 'sgarh':
        //         //         extCode = 'NP';
        //         //         break;
        //         //     case 'pgarh':
        //         //         extCode = 'MUTG';
        //         //         break;
        //         //     case 'slarh':
        //         //         extCode = 'PG2010';
        //         //         break;
        //         //     default:
        //         //     // code block
        //         // }
        //         return extCode
        //         // NP
        //         // MUTG
        //         // PG2010
        //     }
        // }
    }
</script>

<style scoped>

</style>
